import useCurrentUserStore from "@/store";
import { Navigate, Outlet } from "react-router-dom";

export const AppCreationLayout = () => {
  const { dashboardAccessToken } = useCurrentUserStore();
  if (!dashboardAccessToken) {
    return <Navigate to={"/"} />;
  }
  return <Outlet />;
};
